import { useEffect, useState } from "react";
import { Alert, Button, Spinner, Table } from "react-bootstrap";
import { FcApprove, FcDisapprove } from "react-icons/fc";
import Swal from "sweetalert2"; // Import SweetAlert2
import paymentApi from "../../api/paymentApi";

const PendingTransactions = () => {
  const [pendingTransactions, setPendingTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPendingTransactions();
  }, []);

  const fetchPendingTransactions = async () => {
    try {
      const response = await paymentApi.getPendingPaymentStatus();
      setPendingTransactions(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching pending transactions:", error);
      setError(error.message);
      setLoading(false);
    }
  };

  const handleApproveTransaction = async (transactionId) => {
    try {
      await paymentApi.approveTransaction(transactionId);

      Swal.fire({
        title: "Transaction Approved!",
        text: "The transaction has been successfully approved.",
        icon: "success",
        confirmButtonText: "OK",
      });

      fetchPendingTransactions();
    } catch (error) {
      console.error("Error approving transaction:", error);
      setError("Failed to approve transaction. Please try again.");

      Swal.fire({
        title: "Error!",
        text: "Failed to approve the transaction. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleRejectTransaction = async (transactionId) => {
    try {
      await paymentApi.rejectTransaction(transactionId);

      Swal.fire({
        title: "Transaction Rejected!",
        text: "The transaction has been successfully rejected.",
        icon: "success",
        confirmButtonText: "OK",
      });

      fetchPendingTransactions();
    } catch (error) {
      console.error("Error rejecting transaction:", error);
      setError("Failed to reject transaction. Please try again.");

      Swal.fire({
        title: "Error!",
        text: "Failed to reject the transaction. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  return (
    <div className="container mt-4">
      <h2 className="mb-3">Pending Transactions</h2>
      {loading && (
        <div className="text-center mt-4">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}

      {!loading && error && (
        <Alert variant="danger" className="mt-3">
          {error}
        </Alert>
      )}

      {!loading && !error && pendingTransactions.length === 0 && (
        <Alert variant="info" className="mt-3">
          No pending transactions found.
        </Alert>
      )}

      {!loading && pendingTransactions.length > 0 && (
        <Table striped bordered hover responsive className="mt-4">
          <thead>
            <tr>
              <th>Transaction ID</th>
              <th>User</th>
              <th>CompanyName</th>
              <th>Contact</th>
              <th>Collaboration</th>
              <th>Amount</th>
              <th>Requested Credits</th>
              <th>Requested At</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {pendingTransactions.map((transaction) => (
              <tr key={transaction.transactionId}>
                <td>{transaction.transactionId}</td>
                <td>
                  {transaction.userEmail}-{transaction.userId}
                </td>
                <td>{transaction.companyName}</td>
                <td>{transaction.mobileNumber}</td>
                <td>
                  {transaction.collaborationName}
                  {transaction.colabId && transaction.colabId !== 0
                    ? `-${transaction.colabId}`
                    : ""}
                </td>
                <td>{transaction.amount}</td>
                <td>{transaction.creditsRequested}</td>
                <td>{new Date(transaction.createdAt).toLocaleString()}</td>
                <td>
                  <Button
                    variant="success"
                    onClick={() =>
                      handleApproveTransaction(transaction.transactionId)
                    } // Pass transactionId
                  >
                    <FcApprove />
                  </Button>
                  <Button
                    variant="danger"
                    className="ms-2"
                    onClick={() =>
                      handleRejectTransaction(transaction.transactionId)
                    }
                  >
                    <FcDisapprove />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default PendingTransactions;
